import { initializeApp, getApps, getApp } from "firebase/app";
import { getToken, getMessaging, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCrKiUBcoRFbla-b5tZ7YIoXu5oOlU3jnI",
  authDomain: "weeteam-skillzrun.firebaseapp.com",
  databaseURL: "https://weeteam-skillzrun.firebaseio.com",
  projectId: "weeteam-skillzrun",
  storageBucket: "weeteam-skillzrun.firebasestorage.app",
  messagingSenderId: "43386971392",
  appId: "1:43386971392:web:fcda663267fc1b8f07bfe5",
  measurementId: "G-BK5B0LPLBH",
};

/**
 * Возвращает (лениво инициализируя при необходимости) экземпляр Firebase App.
 * Используется как для push-уведомлений, так и для авторизации (Google и др.).
 */
export const getFirebaseApp = () => {
  const apps = getApps();
  if (!apps.length) {
    return initializeApp(firebaseConfig);
  }
  return getApp();
};

/** */
export const isNotificationsSupported = () =>
  "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;

let messaging;
if (isNotificationsSupported()) {
  try {
    const firebaseApp = getFirebaseApp();
    messaging = getMessaging(firebaseApp);
  } catch (e) {
    console.log(e.message);
  }
} else {
  console.log("This browser doesn't support the APIs required to use Firebase SDK.");
}

export let firebaseToken = "";

/**
 * @param {function} setFirebaseToken
 */
export const fetchToken = (setFirebaseToken) => {
  return getToken(messaging, {
    vapidKey: "BFy6FKeSjauWOtn9MPP3YQTTCVxsCOT9Z89ULbESHFMtK7rZKdTSnrdzB6ckPWcFtv9ecLwyI4g0cJfmKBhnmU0",
  })
    .then((currentToken) => {
      if (currentToken) {
        console.log("current token for client: ", currentToken);
        setFirebaseToken(currentToken);
        firebaseToken = currentToken;
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        console.log("No registration token available. Request permission to generate one.");
        setFirebaseToken("");
        firebaseToken = "";
        // shows on the UI that permission is required
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
      // catch error while creating client token
    });
};

/** */
// Map для хранения пар "обработчик -> функция отписки"
const messageListenersUnsubscribes = new Map();

/**
 * Регистрирует обработчик входящих push-сообщений.
 * Возвращает функцию для отписки.
 * @param {function} messageListener
 * @returns {function} unsubscribe
 */
export const onMessageListener = (messageListener) => {
  // Если Firebase Messaging недоступно (браузер не поддерживает или произошла ошибка при инициализации),
  // не пытаемся регистрировать обработчик, чтобы не получить исключение.
  if (!messaging) {
    console.warn("onMessageListener: Firebase messaging недоступно – обработчик не зарегистрирован");
    return () => {};
  }

  const unsubscribe = onMessage(messaging, (payload) => {
    console.log("payload", payload);
    messageListener(payload);
  });
  messageListenersUnsubscribes.set(messageListener, unsubscribe);
  return unsubscribe;
};

/**
 * Снимает ранее зарегистрированный обработчик push-сообщений.
 * @param {function} messageListener
 */
export const offMessageListener = (messageListener) => {
  const unsubscribe = messageListenersUnsubscribes.get(messageListener);
  if (unsubscribe) {
    unsubscribe();
    messageListenersUnsubscribes.delete(messageListener);
  } else {
    console.warn("offMessageListener: обработчик не найден");
  }
};
